type id = string | number;

const BASE =
  process.env.REACT_APP_BACKEND_URL !== undefined
    ? process.env.REACT_APP_BACKEND_URL
    : 'https://soft.sirar.ro';

const admin_legislationAPI = {
  ALL: '/api/AdminLegislation',
  MODIFY: '/api/AdminLegislation',
  ADD: `/api/AdminLegislation`,
  BY_ID: (id: id) => `/api/AdminLegislation/${id}`,
  DELETE: (id: id) => `/api/AdminLegislation/${id}`,
  DOWNLOAD: (id: id) => `/api/AdminLegislation/download/${id}`
};

const admin_curteconturAPI = {
  ALL: '/api/CourtOfAccounts',
  MODIFY: '/api/CourtOfAccounts',
  ADD: `/api/CourtOfAccounts`,
  BY_ID: (id: id) => `/api/CourtOfAccounts/${id}`,
  DELETE: (id: id) => `/api/CourtOfAccounts/${id}`,
  DOWNLOAD: (id: id) => `/api/CourtOfAccounts/download/${id}`
};

const admin_accountsAPI = {
  PRINCIPAL_ACCOUNTS: '/api/users/principal',
  MODIFY_PRINCIPAL_AS_ADMIN: (id: id) => `/api/users/${id}`,
  MODIFY_PRINCIPAL: '/api/users/principal',
  ADD_PRINCIPAL: '/api/users/principal'
};

const admin_notifications = {
  GET_INSPECTIONS: '/api/InspectionDocument/paged',
  GET_INSPECTION: (id: id) => `/api/InspectionDocument/${id}`,
  DOWNLOAD_INSPECTION: (id: id) => `/api/InspectionDocument/download/${id}`,
  UPLOAD_INSPECTION_FILE: '/api/InspectionDocument',
  GET_DECISIONS: '/api/LegalDecision',
  DOWNLOAD_DECISION: (id: id, institutionId: id) =>
    `/api/LegalDecision/download/${institutionId}/${id}`,
  UPLOAD_DECISION_FILE: '/api/LegalDecision',
  UPLOAD_CURTECONTURI_FILE: '/api/CurteConturi'
};

const loginAPI = {
  REFRESH: '/token',
  GET_JWT: '/token',
  LOGOUT: '/session/end',
  REDIRECT:
    process.env.REACT_APP_REDIRECT_URL !== undefined
      ? process.env.REACT_APP_REDIRECT_URL
      : 'https://sirar.ro:3000/signin-oidc',
  LOGIN: (challenge: string) =>
    `${BASE}/auth?client_id=sirar&redirect_uri=${
      process.env.REACT_APP_REDIRECT_URL !== undefined
        ? process.env.REACT_APP_REDIRECT_URL
        : 'https://sirar.ro:3000/signin-oidc'
    }&response_type=code&scope=openid profil&code_challenge=${challenge}&code_challenge_method=S256`
};

const usersAPI = {
  ADMIN_DATA: (id: id) => `/api/users/v1/User/admin/${id}`,
  PRINCIPAL_DATA: (id: id) => `/api/users/v1/User/principal/${id}`,
  PRINCIPAL_DATA_EXT: (id: id) => `/api/users/v1/User/principal/extended/${id}`,
  SECONDARY_DATA: (id: id) => `/api/users/v1/User/secondary/${id}`,
  USER_DATA: (id: id) => `/api/users/v1/User/${id}`
};

/* princial account */

const principal_legislationAPI = {
  ALL: '/api/Legislation',
  MODIFY: '/api/Legislation',
  ADD: `/api/Legislation`,
  BY_ID: (id: id) => `/api/Legislation/${id}`,
  DELETE: (id: id) => `/api/Legislation/${id}`,
  DOWNLOAD: (id: id) => `/api/Legislation/download/${id}`
};

const institutionAPI = {
  ADD: '/api/institutions',
  MODIFY: `/api/institutions`,
  BY_ID: (id: id) => `/api/institutions/${id}`,
  BY_CUI: (cui: string) => `/api/institutions?cui=${cui}`,
  DELETE: (id: id) => `/api/institutions/${id}`,
  GET_ALL_BASIC: '/api/institutions/all/basic',
  GET_ALL: '/api/institutions/all',
  GET_REQUESTS: (id: id) => `/api/institutions/${id}/subordonation-requests`,
  REJECT_REQ: (id: id) => `/api/institutions/reject-institution/${id}`,
  ACCEPT_REQ: (id: id) => `/api/institutions/confirm-institution/${id}`
};

const principal_accountsAPI = {
  SECONDARY_ACCOUNTS: (id: id) => `/api/users/ofPrincipal/${id}`,
  MODIFY_SECONDARY: (id: id) => `/api/users/${id}`,
  ADD_SECONDARY: '/api/users/secondary',
  GET_ALL: '/api/users/secondary',
  GET_SUBORDER_INST: '/api/Institution/all/subordered'
};

const principal_raportsAPI = {
  BY_ID: (id: id) => `/api/CcrReport/${id}`,
  DOWNLOAD: (id: id) => `/api/CcrReport/download/${id}`,
  DELETE: (id: id) => `/api/CcrReport/${id}`,
  GET_ALL: '/api/CcrReport',
  ADD: '/api/CcrReport',
  ARCHIVE: '/api/CcrReport/archive',
  MODIFY: '/api/CcrReport',
  /* followup raports */
  FU_BY_ID: (id: id) => `/api/FollowupCcrReport/${id}`,
  FU_DOWNLOAD: (id: id) => `/api/FollowupCcrReport/download/${id}`,
  FU_DELETE: (id: id) => `/api/FollowupCcrReport/${id}`,
  FU_GET_ALL: '/api/FollowupCcrReport',
  FU_ADD: '/api/FollowupCcrReport',
  /* decision raport */
  DOWNLOAD_DECISION: (id: id) => `/api/DecisionReport/download/${id}`,
  GET_DECISION_RAPORTS: '/api/DecisionReport',
  /* aditional documents */
  ADD_ADOCUMENT: '/api/AdditionalDocument',
  DELETE_DOCUMENT: (id: id) => `/api/AdditionalDocument/${id}`,
  DOWNLOAD_ADOCUMENT: (id: id) => `/api/AdditionalDocument/download/${id}`,
  /* INSTITUTIONS SUBORDERED RAPORTS */
  SUBORDERED_INSTITUTIONS: (institutionId: id) =>
    `/api/Institution/report/subordered/${institutionId}`,
  CCR_REPORT_USERS: (id: id) => `api/CcrReport/${id}/users`,
  CCR_REPORT_USER: (id: id, userId: id) => `api/CcrReport/${id}/users/${userId}`
};

const principal_monitorizationsAPI = {
  BY_ID: (id: id) => `/api/Decision/detailed/${id}`,
  DOWNLOAD: (id: id) => `/api/Decision/download/${id}`,
  ADD: '/api/Decision',
  ALL: '/api/Decision/detailed',
  ALL_DOCUMENTS: (id: id) => `/api/Decision/documents/${id}`,
  /* INSTITUTIONS SUBORDERED MONITORIZATIONS */
  GET_SUBORDERED_MONITORIZATIONS: '/api/Decision/suborderingResumes'
};

const principal_measuresAPI = {
  BY_ID: (id: id) => `/api/DecisionMeasure/${id}`,
  DELETE: (id: id) => `/api/DecisionMeasure/${id}`,
  ADD: '/api/DecisionMeasure',
  ALL: (idDecision: id) =>
    `/api/DecisionMeasure/current/byDecision/${idDecision}`,
  DOWNLOAD_RAPORT_GLOBAL: (id: id, title: string) =>
    `/api/DecisionMeasure/report/${id}/${title}`,
  EDIT_OBSERVATIONS: `/api/DecisionMeasure`,
  DOWNLOAD_RAPORT_MEASURE: (id: id, title: string) =>
    `/api/DecisionMeasure/report/byMeasure/${id}/${title}`
};

const measures_actionsApi = {
  ACTION_STATUS: '/api/DecisionMeasureAction/status',
  ACTION_DEADLINE: '/api/DecisionMeasureAction/deadline',
  ACTION_DOC_STATUS: '/api/DecisionMeasureAction/status-existing-doc',
  ACTION_DOC_DEADLINE: '/api/DecisionMeasureAction/deadline-existing-doc',
  ACTION_DOC_DOWNLOAD: (id: id) => `/api/DecisionMeasureAction/download/${id}`,
  MEASURE_DOCS: (id: id) => `/api/DecisionMeasure/documents/${id}`
};

const principal_notifications = {
  GET_INSPECTIONS: '/api/notifications/v1/Inspection/paged',
  GET_INSPECTION: (id: id) => `/api/notifications/v1/Inspection/${id}`,
  DOWNLOAD_INSPECTION: (id: id) =>
    `/api/notifications/v1/Inspection/download/${id}`,
  UPLOAD_INSPECTION_FILE: '/api/notifications/v1/Inspection',
  /* hotarari */
  GET_DECISIONS: '/api/LegalDecision/paged',
  GET_DECISION: (id: id) => `/api/LegalDecision/${id}`,
  DOWNLOAD_DECISION: (id: id, institutionId: id) =>
    `/api/LegalDecision/download/${institutionId}/${id}`,
  UPLOAD_DECISION_FILE: '/api/LegalDecision',
  /* documents */
  GET_DOCS_NOTIFICATIONS: '/api/notifications/v1/Document/paged',
  /* measurements */
  GET_MEASURES_NOTIFICATIONS: '/api/notifications/v1/MeasureDeadline/paged',
  /* session */
  GET_ACTIONS_NOTIFICATIONS: '/api/notifications/v1/Session/paged',
  /* litigations */
  GET_NOTIFICATIONS: (category: string) => `/api/Notification/${category}`
};

const litigii_api = {
  CALENDAR: 'api/Litigations/calendar',
  GET: 'api/Litigations',
  ADD: 'api/Litigations',
  DELETE: (id: id) => `api/Litigations/${id}`,
  GET_BY_ID: (id: id) => `api/MeasureLitigiiMapping/${id}`,
  DELETE_BY_ID: (id: id) => `api/MeasureLitigiiMapping/${id}`,
  ADD_BY_ID: `api/MeasureLitigiiMapping`,
  GET_DETAILS: (id: id) => `api/Litigations/${id}`,
  UPDATE_LITIGATION: (id: id) => `api/Litigations/${id}`,
  ADD_ARCHIVE_DOCUMENT: `api/Litigations/archive-documents`,
  ADD_DOCUMENT: `api/Litigations/documents`,
  UPDATE_DOCUMENT: (id: id) => `api/Litigations/documents/${id}`,
  DOWNLOAD_DOCUMENT: (id: id) => `api/Litigations/documents/download/${id}`,
  DOWNLOAD_ARCHIVE_DOCUMENT: (id: id) =>
    `api/Litigations/archive-documents/download/${id}`,
  DOWNLOAD: `api/Litigations/download`,
  IMPORT: `api/Litigations/import`,
  LITIGATION_USERS: (id: id) => `api/Litigations/${id}/users`,
  LITIGATION_USER: (id: id, userId: id) =>
    `api/Litigations/${id}/users/${userId}`
};

const situatie_api = {
  GET_ONE: (year: string) => `api/InstitutionTabel/tableInfo/${year}`,
  DELETE_ROW: (year: string, id: string) =>
    `api/InstitutionTabel/tabelEntry/${year}/${id}`,
  UPDATE: `api/InstitutionTabel/tableInfo`,
  GET_ALL: `api/InstitutionTabel/tableInfo`
};

const authorizationAPI = {};

export {
  BASE,
  institutionAPI,
  usersAPI,
  authorizationAPI,
  loginAPI,
  admin_legislationAPI,
  admin_accountsAPI,
  principal_legislationAPI,
  principal_accountsAPI,
  principal_raportsAPI,
  principal_monitorizationsAPI,
  principal_measuresAPI,
  admin_notifications,
  measures_actionsApi,
  principal_notifications,
  litigii_api,
  situatie_api,
  admin_curteconturAPI
};
